export function sponsorSearch(sponsors, searchText) {
  const q = (searchText || "").toLowerCase().trim();
  if (!q) return sponsors ?? [];
  return (sponsors ?? []).filter((o) => {
    const first = (o.FirstName || "").toLowerCase();
    const last = (o.LastName || "").toLowerCase();
    const email = (o.Email || "").toLowerCase();
    const title = (o.Title || "").toLowerCase();
    const org = (o.OrganizationName || "").toLowerCase();
    const state = (o.OrgState || "").toLowerCase();
    const full = `${first} ${last}`.trim();
    return (
      first.includes(q) ||
      last.includes(q) ||
      email.includes(q) ||
      title.includes(q) ||
      org.includes(q) ||
      state.includes(q) ||
      full.includes(q)
    );
  });
}